// Centralized environment variable access with minimal typing.
// These values are injected at build time via Webpack DefinePlugin.
// We expect DefinePlugin to replace process.env.* with string literals.
// Coerce and validate here; provide safe fallbacks.
export const env = {
    APP_DISPLAY_NAME: process.env.APP_DISPLAY_NAME || 'IPMFEHost',
    APP_VERSION: process.env.APP_VERSION || '0.0.0',
    PUBLIC_PATH: process.env.PUBLIC_PATH || '/',
    REMOTE_MANIFEST_URL: process.env.REMOTE_MANIFEST_URL || '',
    LOG_LEVEL: process.env.LOG_LEVEL || 'info',
    // Raw string values only — do NOT compare here (see AppEnv note above).
    // The `|| 'true'` / `|| 'false'` fallbacks ensure we always keep a string value
    // so the production placeholder survives minification and the deploy-time `sed`
    // substitution can replace it.
    FEATURE_FLAG_EXPERIMENTAL: process.env.FEATURE_FLAG_EXPERIMENTAL || 'false',
    // Default-on flags: absent/empty => 'true' (visible).
    FEATURE_FLAG_HOME: process.env.FEATURE_FLAG_HOME || 'true',
    FEATURE_FLAG_DATA_AGENT: process.env.FEATURE_FLAG_DATA_AGENT || 'true',
    FEATURE_FLAG_DATA_DISCOVERY: process.env.FEATURE_FLAG_DATA_DISCOVERY || 'true',
    FEATURE_FLAG_SALES_GC: process.env.FEATURE_FLAG_SALES_GC || 'true',
    FEATURE_FLAG_SHOW_ANALYTICAL_PATHWAYS: process.env.FEATURE_FLAG_SHOW_ANALYTICAL_PATHWAYS || 'true',
    REMOTE_COMPARABILITY_URL: process.env.REMOTE_COMPARABILITY_URL || 'http://localhost:9001/remoteEntry.js',
    TRUSTED_MFE_ORIGINS: process.env.TRUSTED_MFE_ORIGINS || 'localhost|cdn.example.com',
    REMOTE_DATADISCOVERY_URL: process.env.REMOTE_DATADISCOVERY_URL || 'http://localhost:3003/remoteEntry.js',
    REACT_APP_SSO_ENABLED: process.env.REACT_APP_SSO_ENABLED || 'true',
    REACT_APP_AUTH_AUTHORITY: process.env.REACT_APP_AUTH_AUTHORITY || 'AUTHORITY NOT SET',
    REACT_APP_CLIENT_ID: process.env.REACT_APP_CLIENT_ID || 'CLIENT ID NOT SET',
    REACT_APP_REDIRECT_URI: process.env.REACT_APP_REDIRECT_URI || 'REDIRECT URI NOT SET',
    REACT_APP_LOGIN_URL: process.env.REACT_APP_LOGIN_URL || 'LOGIN URL NOT SET',
    REACT_APP_API_URL: process.env.REACT_APP_API_URL || 'API URL NOT SET',
    REACT_APP_PATHWAYS_URL: process.env.REACT_APP_PATHWAYS_URL || 'PATHWAYS URL NOT SET',
    REACT_APP_COPILOTKIT_RUNTIME_URL: process.env.REACT_APP_COPILOTKIT_RUNTIME_URL || 'RUNTIME URL NOT SET',
    REACT_APP_AGENT_URL: process.env.REACT_APP_AGENT_URL || 'AGENT URL NOT SET',
    // Fallback order: injected env var → empty string (tracking disabled).
    // Set GA_MEASUREMENT_ID in .env.local for local testing (e.g. G-2YYL3HMKYE).
    // DEV  -> G-2YYL3HMKYE  (set via pipeline sentinel substitution)
    // PPD  -> G-J6P7TFSY7L  (set via pipeline sentinel substitution)
    // PRD  -> G-3VLJ4V5P1E  (set via pipeline sentinel substitution)
    GA_MEASUREMENT_ID: process.env.GA_MEASUREMENT_ID || '',
    ENABLE_ANALYTICS: process.env.ENABLE_ANALYTICS || 'false',
    RBAC_LIMITED_ACCESS: process.env.RBAC_LIMITED_ACCESS || '',
    RBAC_US_DATA_ONLY: process.env.RBAC_US_DATA_ONLY || '',
};
export function isExperimentalEnabled() {
    // Compared at runtime (not build time) so the injected placeholder survives
    // minification and the deploy-time value actually takes effect.
    return env.FEATURE_FLAG_EXPERIMENTAL === 'true';
}
export function shouldLog(level) {
    const order = ['debug', 'info', 'warn', 'error'];
    return order.indexOf(level) >= order.indexOf(env.LOG_LEVEL);
}
